<template>
    <div>

        <div class="sign-header_yi">
            <div class="fill">
                <img class="sign-header-img" src="@/assets/img/logins.png"/>
            </div>
            <div>
                <div class="mob_hamburger" @click="showPopup">
                    <div class="nav_btn">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
            <van-popup v-model="show" position="left" :style="{ height: '100%' ,width:'95%',overflow: 'hidden'}">
                <div class="fill">
                    <img class="sign-header-img" src="@/assets/img/logins.png"/>
                </div>

                <div class="mob_hamburger mob_hamburger_1">
                    <div class=" toggle_animate" @click="closeClick">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                <el-menu
                        :default-active="defaultActive"
                        class="el_menu"
                        mode="vertical"
                        :router="true"
                        :unique-opened="true"
                >
                    <!-- submenu：菜单栏中的一项 index: 它的标识（唯一）-->
                    <template v-for="(item, index) in menusList">
                        <el-menu-item class="el_item_me" :key="index+'_001'" v-if="item.chirdren == null&& item.code != 1"
                                      :index="item.name" @click="closeClick">
                            <span>{{ item.title }}</span>
                        </el-menu-item>
<!--                        <li role="menuitem" tabindex="0" class="el-menu-item el_item_me "  :key="index+'_001'"-->
<!--                            v-if="item.chirdren == null&& item.code == 1" @click="official_website">-->
<!--                            <span>{{ item.title }}</span>-->
<!--                        </li>-->
                        <el-submenu
                                v-if="item.chirdren !== null"
                                :key="index+'_003'"
                                :index="item.id.toString()"
                                class="_submenu"
                        >
                            <template slot="title">
                                <!--                                <i class="el-icon-location"></i>-->
                                <span>{{ item.title }}</span>
                            </template>
                            <!-- 判断是否最后一级子元素 -->
                            <template v-if="item.chirdren !== null">
                                <template v-for="(item1, index1) in item.chirdren">
                                    <!-- 如果不是最后一级 -->
                                    <template v-if="item1.chirdren !== null">
                                        <el-submenu :key="index1" :index="item1.name">
                                            <template slot="title">
                                                <!--                                                <i class="el-icon-location"></i>-->
                                                <span>{{ item1.title }}</span>
                                            </template>
                                            <el-menu-item
                                                    v-for="(item2, index2) in item1.chirdren"
                                                    :key="index2"
                                                    :index="item2.name"
                                            >
                                                <!--                                                <i class="el-icon-s-grid"></i>-->
                                                <span>{{ item2.title }}</span>
                                            </el-menu-item>
                                        </el-submenu>
                                    </template>
                                    <!-- 如果是最后一级 -->
                                    <template v-else>
                                        <el-menu-item :key="index1+'_002'" :index="item1.name" @click="closeClick">
                                            <!--                                            <i class="el-icon-s-grid"></i>-->
                                            <span>{{ item1.title }}</span>
                                        </el-menu-item>
                                    </template>
                                </template>
                            </template>
                        </el-submenu>
                    </template>
                </el-menu>
                <div class="mob_login">
                    <el-button class="p " @click="Personal_center_h5">登录</el-button>
                    <el-button class="p " @click="Personal_center_h5_s">注册</el-button>
                </div>
            </van-popup>

        </div>
        <div class="sign-header">
            <div class="fill" @click="$router.push({path: '/home_page'})">
                <img class="sign-header-img" src="@/assets/img/logins.png"/>
                <h1 class="h1_top">大众签章一体化电子合同平台</h1>
            </div>
            <el-menu
                    :default-active="defaultActive"
                    class="nav pc_block clearfix"
                    mode="horizontal"
                    :router="true"
                    :unique-opened="true"
            >
                <!-- submenu：菜单栏中的一项 index: 它的标识（唯一）-->
                <template v-for="(item, index) in menusList">
                    <el-menu-item class="el_item_me" :key="index+'_001'" v-if="item.chirdren == null&& item.code != 1"
                                  :index="item.name">
                        <h1>{{ item.title }}</h1>
                    </el-menu-item>
                    <li role="menuitem" tabindex="0" class="el-menu-item el_item_me "  :key="index+'_001'"
                        v-if="item.chirdren == null&& item.code == 1" @click="official_website">
                        <h1>{{ item.title }}</h1>
                    </li>
                    <el-submenu
                            class="el_submenu"
                            v-if="item.chirdren !== null"
                            :key="index+'_003'"
                            :index="item.id.toString()"
                    >
                        <template slot="title">
                            <!--                            <i class="el-icon-location"></i>-->
                            <h1>{{ item.title }}</h1>
                        </template>
                        <!-- 判断是否最后一级子元素 -->
                        <template v-if="item.chirdren !== null">
                            <template v-for="(item1, index1) in item.chirdren">
                                <!-- 如果不是最后一级 -->
                                <template v-if="item1.chirdren !== null">
                                    <el-submenu :key="index1" :index="item1.name">
                                        <template slot="title">
                                            <i class="el-icon-location"></i>
                                            <span>{{ item1.title }}</span>
                                        </template>
                                        <el-menu-item
                                                v-for="(item2, index2) in item1.chirdren"
                                                :key="index2"
                                                :index="item2.name"
                                        >
                                            <!--                                            <i class="el-icon-s-grid"></i>-->
                                            <h1>{{ item2.title }}</h1>
                                        </el-menu-item>
                                    </el-submenu>
                                </template>
                                <!-- 如果是最后一级 -->
                                <template v-else>
                                    <el-menu-item :key="index1+'_002'" :index="item1.name">
                                        <!--                                        <i class="el-icon-s-grid"></i>-->
                                        <h1>{{ item1.title }}</h1>
                                    </el-menu-item>
                                </template>
                            </template>
                        </template>
                    </el-submenu>
                </template>
                <el-button class="index_href_one " @click="Personal_center">登录</el-button>
                <el-button class="index_href_one1 " @click="Personal_center_s">注册</el-button>
            </el-menu>

        </div>


    </div>

</template>
<script>
    export default {
        name: "Header",
        data() {
            return {
                show: false,
                menusList: [
                    {
                        name: "/home_page",
                        id: '1',
                        title: "首页",
                        chirdren: null
                    },
                    {
                        id: '2',
                        title: "产品中心",
                        chirdren: [
                            {
                                title: "产品介绍",
                                name: "/products/productCente",
                                chirdren: null
                            }, {
                                title: "产品下载",
                                name: "/products/productDownload",
                                chirdren: null
                            }]
                    }, {
                        id: '3',
                        title: "解决方案",
                        chirdren: [
                            {
                                title: "电子政务",
                                name: "/programme/indusSolutionGovern",
                                chirdren: null
                            }, {
                                title: "电子商务",
                                name: "/programme/indusSolutionAffair",
                                chirdren: null
                            }, {
                                title: "保险信贷",
                                name: "/programme/indusSolutionSecure",
                                chirdren: null
                            }, {
                                title: "旅游行业",
                                name: "/programme/indusSolutionTour",
                                chirdren: null
                            }, {
                                title: "房屋租赁",
                                name: "/programme/indusSolutionRent",
                                chirdren: null
                            }]
                    },
                    {
                        name: "/lawProtect",
                        id: '4',
                        title: "使用保障",
                        chirdren: null
                    },
                    {
                        code: 1,
                        id: '11',
                        title: "开放平台",
                        chirdren: null
                    },
                    {
                        id: '5',
                        title: "新闻资讯",
                        chirdren: [
                            {
                                title: "行业动态",
                                name: "/news/newsHy/3",
                                chirdren: null
                            }, {
                                title: "政策法规",
                                name: "/news/newsHy/4",
                                chirdren: null
                            }, {
                                title: "合同百科",
                                name: "/news/newsHy/6",
                                chirdren: null
                            }, {
                                title: "法律知识",
                                name: "/news/newsHy/7",
                                chirdren: null
                            }]
                    }, {
                        id: '7',
                        title: "关于我们",
                        chirdren: [
                            {
                                title: "公司介绍",
                                name: "/about/aboutUs",
                                chirdren: null
                            }, {
                                title: "公司新闻",
                                name: "/news/newsHy/2",
                                chirdren: null
                            }, {
                                title: "联系我们",
                                name: "/about/aboutUsAddress",
                                chirdren: null
                            }, {
                                title: "帮助中心",
                                name: "/about/helpCenter",
                                chirdren: null
                            }, {
                                title: "招聘信息",
                                name: "/about/aboutUsEmploy",
                                chirdren: null
                            }]
                    },
                    {
                        name: "/contractIden",
                        title: "合同鉴真",
                        id: '8',
                        chirdren: null
                    },

                ],
            };
        },
        created() {
            var pagename_one = window.location.host
            if (pagename_one.indexOf("aiosign.com") >= 0) {
                this.new_url = 'https://' + pagename_one
            } else {
                this.new_url = this.$SIF.get_url
            }
        },
        watch: {},
        computed: {
            defaultActive() {
                return this.$route.path;
            }
        },
        methods: {
            showPopup() {
                this.show = true;
            },
            closeClick() {
                this.show = false;
            },
            Personal_center() {

                // window.location.href='https://aiosign.com/web/index.html#/acounts/login'
                window.open(this.new_url+'/web/index.html#/acounts/login')
            },
            Personal_center_s() {
                // window.location.href='https://aiosign.com/web/index.html#/account/'
                window.open(this.new_url+'/web/index.html#/account/')
            },
            Personal_center_h5() {
                // window.location.href='https://aiosign.com/h5/index.html#/login'
                window.open(this.new_url+'/h5/index.html#/login')
            },
            Personal_center_h5_s() {
                // window.location.href='https://aiosign.com/h5/index.html#/register/registercompany'
                window.open(this.new_url+'/h5/index.html#/registercompany')
            },
            official_website() {
                window.open('https://open.aiosign.com')
            },
        }
    };
</script>
<style scoped lang="scss">
    * {
        -webkit-touch-callout: none; /*系统默认菜单被禁用*/
        -webkit-user-select: none; /*webkit浏览器*/
        -khtml-user-select: none; /*早期浏览器*/
        -moz-user-select: none; /*火狐*/
        -ms-user-select: none; /*IE10*/
        user-select: none;
    }

    .fill {
        cursor: pointer;
    }

    input {
        -webkit-user-select: auto; /*webkit浏览器*/
    }

    textarea {
        -webkit-user-select: auto; /*webkit浏览器*/
    }

    .ee_butt {
        color: #2b8d61;
        font-size: 16px;
        width: 100px;
        margin: 0 20px;
        display: inline-table;
        height: 60px;
        line-height: 60px;
        padding: 0;
    }

    .ee_butt:hover {
        color: #0FC87D;
        text-decoration: underline;
    }

    .sign-header {
        display: flex;
        justify-content: space-between;
        background-color: $top-color;
        height: 70px;
        align-items: center;
        border-bottom: 1px #bcc7c1 solid;
        font-family: PingFangSC-Regular, PingFang SC;
        width: 1400px;
        margin: 0 auto;
    }

    .nav {
        border: none;
        display: flex;
    }

    .nav ul {
        white-space: nowrap;
    }

    .sign-header /deep/ .el-submenu__title,
    .sign-header /deep/ .el-menu-item {
        font-size: 16px;
        text-align: center;
        border: none;
    }

    .el-menu.el-menu--horizontal {
        border: none;
    }

    .sign-header-img {
        width: auto;
        max-width: 100%;
    }

    .sign-header /deep/ .submenu__title.is-active,
    .sign-header /deep/ .el-menu-item.is-active {
        font-weight: bold;
        border: none;
    }

    .head_l {
        display: flex;
    }

    .userinfo {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-right: 1px #979797 solid;
        position: relative;
        cursor: pointer;
    }

    .userinfo .photo {
        height: 50px;
        width: 50px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 20px;
        margin-left: 17px;
    }

    .el_img {
        width: 100%;
        height: 100%;
    }

    .userinfo .photo img {
        width: 100%;
        height: 100%;
    }

    .userinfo .butn {
        font-size: 20px;
        color: #3b6c56;
        font-weight: 700;
        margin-left: 19px;
        margin-right: 28px;

        -webkit-transition: all 0.3s ease-out;
        -moz-transition: all 0.3s ease-out;
        -ms-transition: all 0.3s ease-out;
        transition: all 0.3s ease-out;
    }

    .userinfo .butn.open {
        transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        -webkit-transform: rotate(180deg);
        -o-transform: rotate(180deg);
    }

    .pull_down_box {
        position: absolute;
        top: 60px;
        left: 0px;
        width: 100%;
        height: 94px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 6px 0px rgba(135, 135, 135, 0.16);
        border-radius: 0px 0px 3px 3px;
        overflow: hidden;
        z-index: 9;
    }

    .pull_down_box > div {
        height: 47px;
        padding-left: 33px;
        font-size: 12px;
        color: #2b8d61;
        line-height: 47px;
    }

    .pull_down_box > div li {
        font-size: 18px;
        margin-right: 17px;
        vertical-align: middle;
    }

    .pull_down_box > div:hover {
        background: rgba(49, 202, 132, 0.1);
    }

    .user_name {
        color: #278e60;
        font-size: 16px;
        line-height: 24px;
    }

    .user_name .name {
        font-weight: 700;
    }

    .index_href_one {
        padding: 0px 25px;
        height: 28px;
        line-height: 28px;
        background: #06C36F;
        color: #E9F9F2;
        border-radius: 15px;
        text-align: center;
        font-size: 14px;
        margin: 19px 10px;
        cursor: pointer;
        width: 90px;
        margin-left: 48px;
    }

    .index_href_one1 {
        padding: 0px 25px;
        height: 28px;
        background: #CFF4E3;
        color: #218C5C;
        line-height: 28px;
        border-radius: 15px;
        text-align: center;
        margin: 19px 0;
        font-size: 14px;
        width: 90px;
        cursor: pointer;
    }

    .mob_login {
        height: 50px;
        position: sticky;
        bottom: 0;
        left: 0;
        width: 100%;
    }

    .mob_login .p {
        float: left;
        width: 44%;
        box-sizing: border-box;
        display: inline-block;
        height: 45px;
        line-height: 42px;
        text-align: center;
        border: 2px solid #A9D7C4;
        font-size: 22px;
        color: #218C5C;
        background-color: #fff;
        margin: 0 3%;
        padding: 0;
    }

    @media screen and (max-width: 1024px) and (min-width: 320px) {
        .sign-header-img {
            margin-left: 2.333rem;
            margin-top: 11px;
            height: 2.5rem;
            margin-bottom: 11px;
        }
        .fill {
            background: #ffffff;
            padding: 5px;
        }
        .mob_hamburger_1 > > > .toggle_animate span {
            opacity: 1 !important;
            transform: rotate(45deg) !important
        }
        .mob_hamburger_1 > > > .toggle_animate span:nth-child(2) {
            width: 0 !important;
            opacity: 0 !important;
            transform: rotate(0) !important;
            transition: width .3s !important;
        }
        .mob_hamburger_1 > > > .toggle_animate span:last-child {
            opacity: 1 !important;
            transform: rotate(-45deg) !important;
        }
        .el_menu {
            height: -webkit-calc(100% - 100px);
            height: -moz-calc(100% - 100px);
            height: calc(100% - 100px);
            overflow-y: auto;
            overflow-x: hidden;
        }
    }

</style>
<style>
    .el-menu--horizontal > .el-submenu .el-submenu__title:hover {

        background: none;
    }
    .h1_top{
        z-index: -1;
        position: absolute;
        top: 32px;
        color: rgba(0,0,0,0);
    }
    h1{
        font-weight: 500;
    }
</style>